export default {
    Login: 'Sign in',
    LoginEmpty: 'Sign in',
    ToLogin: 'To login',
    WelcomeTo: 'Welcome to',
    GaoDengMRT: 'GOLDEN FAST INT’L LOGISTICS CO.,LTD',
    TFICompany: 'International Station Platform, Finance and Taxation, International Logistics Transportation as One Supply Chain Company',
    TeamServiceChoice: 'Professional team, quality service, your best choice !',
    Home: 'Home',
    Service: 'Service',
    Provide: 'Provide',
    AboutUs: 'About us',
    QuotationInquiry: 'Quotation inquiry',
    Regist: 'Regist',
    RegistEmpty: 'Regist',
    ToRegist: 'To regist',
    EenterUserName: 'Please enter the user name',
    EenterCompanyName: 'Please enter the company name',
    EenterPassword: 'Please enter the password',
    EenterCode: 'Please enter the verification code',
    GraphicsCode: 'Graphics verification code',
    NoAccount: 'No account',
    ExistingAccounts: 'Existing accounts',
    WeProvide: 'We offer : first-class supply chain services',
    Profile: 'Profile',
    Team: 'Team',
    Address: 'Address',
    FastLink: 'Fast link',
    CommercialService: 'Commercial service',
    SenseOfValue: 'sense of value',
    RegisteredInLonggang: "Established in 2011,4 branches at moment,we are a full service freight forwarding and logistics company. Our partners with businesses worldwide to provide innovative logistics solutions around the globe. Our flexibility, personalized/tailored services and dedicated team are the key to our high level of customers'satisfaction and loyalty. Inquiries about ourselves and the way we do business are welcome.",
    ThoughtHonestyService: 'Thought, honesty and service are the golden triangle of our value',
    InternationalPlatform: 'International station platform diagnosis',
    NternationalLogistics: 'Nternational logistics',
    FiscalAndTaxationServices: 'Fiscal and taxation services',
    YushangSalon: 'Yushang Salon',
    Headquarters: 'Shenzhen Gaodeng International Freight Forwarding Co., Ltd. ( Headquarters )',
    HeadquartersAddress: 'Pearl River at the intersection of Longxiang Avenue and Construction Road, Longcheng Street, Longgang District, Shenzhen City',
    JiangxiBranch: 'Jiangxi Tiger Enterprise Service Co., Ltd. ( Jiangxi Branch )',
    JiangxiBranchAddress: 'Room 1105 – 1110, Block AB, Central Peak, 1368 Honggu Road, Nanchang City',
    NanningBranch: 'Shenzhen Gaodeng International Freight Forwarding Co., Ltd. ( Nanning Branch )',
    NanningBranchAddress: 'Jinyuan CBD Modern City, 63 Jinhu Road, Qingxiu District, Nanning City, Guangxi 2333-2337',
    DongguanBranch: 'Dongguan Gaodeng International Freight Forwarding Co., Ltd. ( Dongguan Branch )',
    DongguanBranchAddress: 'Taishang Building, No. 11 Dongguan Avenue, Dongguan City, 2308',
    SenseOfValueText: 'Honesty is our rule of doing things. The height of thought determines the depth of service. What we pursue is the specialization of service. Global service network to create a perfect service system, all for you !',
    RecordNumber: 'Record number',
    RecordNumberText: 'Guangdong ICP 13013856',
    SelectingServing: 'selecting serving',
    PswGreaterSix: 'Password length greater than six bits',
    CodeLengthFour: 'Verification code length of four bits',
    AlibabaSupplyChainServices: 'Alibaba supply chain services',
    AlibabaSupplyChainServicesIntroduct: 'In 2015, Ali Packaging Project assists Ali International Station platform guest receipts, financing, website diagnosis, logistics and transportation services.',
    InternationLogisticsTransporation: 'internation logistics transporation',
    InternationLogisticsTransporationIntroduct: 'Since its establishment in 2011, the company has cooperated with customers in the export logistics and transportation arrangements, the whole cabinet, bulk cargo, air transportation, express delivery, special line transportation and the arrangement of trailer, customs declaration, certificate of origin, insurance and other services.',
    InternationLogisticsTransporationIntroduct2: "Established in 2011,4 branches at moment,we are a full service freight forwarding and logistics company. Our partners with businesses worldwide to provide innovative logistics solutions around the globe. Our flexibility, personalized/tailored services and dedicated team are the key to our high level of customers'satisfaction and loyalty. Inquiries about ourselves and the way we do business are welcome.Our Service: 1,Export/Import Logistics ServiceOcean Freight FCL/LCLAir FreightLand Transport 2,Customs BrokerLicense & Certificate Application  3,Warehouse Service 4,Trucking Service 5,Door to Door Servcie 6,D.G HazMat Transportation 7,Freezer Transportation 8,Project Cargo",
    JointProfessional: 'Joint regulation, professional tax collection',
    JointProfessionalIntroduct: 'Combined with the actual situation of enterprise management, the comprehensive use of national tax preferential policies for enterprises and individuals to achieve legal compliance tax law and tax interoperability, strategic design : help enterprises to build equity structure, reengineering the internal control process, optimize the transaction structure, do top-level design, realize long-term development.',
    InternationalStationPlatform: 'International station platform',
    InternationalStationPlatformIntroduct: 'Excellent international station platform diagnosis, help you improve the international station platform product placement, product setting, freight template setting, fiscal and taxation settings',
    InternationalLogistics: 'international logistics',
    InternationalLogisticsIntroduct: 'Professional logistics service team, solve your logistics service pain points, booking, trailer, customs declaration, certificate of production, insurance one-stop service',
    FiscalAndTaxationServices: 'Fiscal and taxation services',
    FiscalAndTaxationServicesIntroduct: 'Ali certified fiscal and taxation services to solve the professional problems of tax rebates, high quality services to solve the pain points of tax rebate difficulties',
    YushangSalon: 'Yushang Salon',
    YushangSalonIntroduct: '60 square meters training site, regular platform knowledge, logistics knowledge, tax knowledge training. Solving Link Closed Loop and Training Professionals for Customers',
    InternationalDiagnosticReservation: 'International Diagnostic Reservation',
    WholeContainerShipping: 'Whole container shipping',
    LandTransportContainer: 'Land transport container',
    BulkShipping: 'Bulk shipping',
    InternationalExpress: 'international express',
    FiscalAndTaxationServices: 'Fiscal and taxation services',
    heading: 'heading',
    PleaseEnter: 'Please enter',
    PleaseSelect: 'Please select',
    SelectDate: 'select date',
    ThisPort: 'This port ',
    WarehouseExplosion: 'warehouse explosion',
    Or: ' or ',
    OffPort: 'Off-port',
    Please: 'please',
    Offline: ' offline ',
    IndividualPriceConfirmation: 'Individual price confirmation',
    ContactUs: 'Contact us',
    NoSearchData: 'There is no search data yet',
    EssentialInformation: 'essential information',
    ChargeWeight: 'charge weight',
    Volume: 'volume',
    NumberOfPieces: 'Number of pieces',
    Box: 'box ',
    GoodsType: 'goods type',
    Invoice: 'Invoice',
    WhetherToSupplement: 'Whether to supplement',
    Yes: 'yes ',
    No: 'no',
    ClickUpload: 'ClickUpload',
    Sensitive : 'sensitive',
    GoodsDetails: 'Goods Details',
    NeedOffline: ' Need separate confirmation offline',
    EnterGoodsDetails: 'Please enter the details of the goods',
    DepartureCost: 'port of departure cost',
    CostName: 'Cost name',
    Currency : 'currency ',
    Cost: 'cost ',
    Subtotal: 'subtotal',
    Remarks: 'remarks',
    DestinationCost: 'destination port cost',
    ShippingCosts: 'Shipping costs',
    VolumeGrossWeight: 'Volume weight and gross weight are calculated at large values',
    ActualConfirmed: 'Actual costs are confirmed before shipment',
    ConfirmOrder: 'Confirm the Order',
    Ordinary: 'ordinary',
    NoLogin: 'You have not logged in yet, now log in ?',
    Prompt: 'Prompt ',
    OK: 'OK',
    Cancel: 'Cancel ',
    cargoTypeCanNotBeEmpty: 'cargo type can not be empty!',
    GoodsDetailsCannotBeEmpty: 'goods details cannot be empty!',
    InvoiceCannotBeEmpty: 'invoice cannot be empty!',
    SuccessfulOrder: 'successful order!',
    SuccessfulUpload: 'successful upload!',
    UploadFailed: 'Upload failed ! ',
    UploadLimit10: 'Upload image size can not exceed 10MB !',
    Destinatio: 'port of destination',
    EnterDestinatio: 'choose the destination port',
    PackagingType: 'packaging type',
    ChoosePackagingType: 'choose packing type',
    TotalGrossWeight: 'total gross weight',
    EnterGrossWeight: 'enter gross weight',
    Long: 'long',
    EnterLong: 'enter long',
    Wide: 'wide',
    EnterWide: 'enter wide',
    High: 'high ',
    EnterHigh: 'enter high',
    NumberPieces: 'number of pieces',
    EnterNumber: 'enter number',
    SelectGoodsType: 'select the goods type',
    Type: 'type',
    SearchQuote: 'search quote',
    NoHistorical: 'No historical search data',
    DestinationName: 'area name',
    DestinationCode: 'area code',
    RouteCode: 'specify route',
    RouteName: 'route name',
    TotalCostCNY: 'total cost CNY',
    UnitPriceCNY: 'unit price CNY',
    FreightCNY: 'freight CNY',
    Surcharge: 'surcharge ',
    VolumeNumber: 'volume divided by number',
    DisableGoods: 'type of prohibited goods',
    ExtractionAging: 'extraction time',
    WorkingDay: 'working day',
    IndateBegin: 'effective time',
    Descriptions: 'Remarks',
    Operation: 'operation',

    BusinessNumber: 'business number',
    OrderState: 'order state',
    EnterBusinessNumber: 'enter the business number',
    SelectOrderState: 'select the order state',
    SearchOrder: 'search order',
    Determined: 'determined',
    Cost: 'cost',
    TransportMode: 'transport mode',
    Voyage: 'voyage',
    Time: 'time',
    OrderNumber: 'order number',
    Direct: 'direct',
    Transshipment: 'transshipment',
    Day: 'day',
    CreateTime: 'create time',
    NextOrderTime: 'next order time',
    All: 'all',
    Submitted: 'submitted',
    Ordered: 'ordered',
    SelectStartingPort: 'select the starting port',
    SelectDestinationPort: 'choose the destination port',
    SearchFreight: 'search freight',
    HistoricalSearch: 'historical search',
    NoHistoricalSearchData: 'no historical search data',
    StartingPort: 'starting port',
    DestinationPort: 'destination port',
    Weight: 'weight',
    Volume: 'volume',
    EnterWeight: 'enter weight',
    EnterVolume: 'enter volume',
    DeparturePort: 'departure port',
    ClosingDate: 'closing date',
    DateOfShipment: 'date of shipment',
    DurationOfValidity: 'duration of validity',
    SeaFreight: 'sea freight',
    Freight: 'freight',
    Operation: 'operation',
    ViewDetail: 'view detail',
    ClickSearchPriceData: 'click search price search data',
    NoteBelow: 'note below',
    SpellStraight: 'direct splicing',
    StartingPortNotEmpty: 'The starting port cannot be empty !',
    DestinationPortNotEmpty: 'The port of destination cannot be empty !',
    WeightvolumeGreaterThan0: 'Weight and volume need to be greater than 0 !',
    BasicInformation: 'basic information',
    ShipCompany: 'ship company',
    TransitPort: 'transit port',
    BookingInstructions: 'booking instructions',
    Nothing: 'nothing',
    ValueAddedServices: 'value added services',
    DeparturePortCost: 'departure port cost',
    CostName: 'cost name',
    Currency: 'currency',
    Subtotal: 'subtotal',
    DestinationPortCost: 'destination port cost',
    OceanFreight: 'Ocean freight',
    NotIncludeOtherBoxesCost: 'Does not include part of the cost of other boxes',
    ActualCostsConfirmedBeforeShipment: 'Actual costs are confirmed before shipment',
    ConfirmShipment: 'confirm shipment',
    NotLogged: 'You have not logged in yet, now log in ?',
    Prompt: 'prompt',
    OK: 'OK',
    Cancel: 'Cancel',
    SuccessfulShipment: 'successful shipment',
    
    BusinessInformation: 'Business Information',
    ConfirmOrder: 'confirm the order',
    EnterDelegateUnit: 'enter the delegate unit',
    EnterSettlementUnit: 'enter the settlement unit',
    EnterBillLading: 'enter the bill of lading',
    ChooseBoxQuantity: 'choose the box quantity',
    EnterShipper: 'enter the shipper',
    EnterConsignee: 'enter the consignee',
    EnterNotifier: 'enter the notifier',
    EnterMark: 'enter the mark',
    EnterGoodsDescription: 'enter the description of the goods',
    EnterBillLadingName: 'enter the bill of lading name',
    EnterDestination: 'enter destination',
    EnterEnterBillLadingNotes: 'enter the bill of lading notes',
    EnterEnterBillLadingNotesNotPrint: 'enter the bill of lading note / not print',
    DelegateNotes: 'delegate notes',
    Shipper: 'shipper',
    Consignee: 'consignee',
    Informer: 'informer',
    Mark: 'mark',
    CargoDescription: 'cargo description',
    BillLadingName: 'name of bill of lading',
    BillLadingNotes: 'notes to bill of lading',
    SuccessfulUpload: 'successful upload !',
    UploadFailed: 'upload failed !',
    UploadImageFormatPDF: 'upload image only in PDF format !',
    UploadImageFormatSize: 'upload image size can not exceed 10MB !',
    SuccessfulOrder: 'successful order !',
    ThereAreAlsoUnfilledItems: 'there are also unfilled items !',
    SailingDate: 'sailing date',
    SelectSailingDate: 'select the sailing date',
    SelectShippingCompany: 'select a shipping company',
    SelectTransportMode: 'select transport mode',
    ShippingDate: 'shipping date',
    Section: 'section',
    Open: 'open',
    ShippingSpaceStatus: 'shipping space status',
    ContactUs: 'contact us',
    NoOrdersAllowed: 'No orders allowed !',
    ShippingSpace: 'shipping space',
    CabinetType: 'Cabinet type',
    OtherBoxType: 'Other box type',
    SingleTicketBox: 'Single ticket / box',
    ConfirmPriceOffline: 'confirm the price separately offline !',
    Carton: 'carton',
    WoodenCase: 'Wooden case',
    CardBoard: 'Card board',
    Express: 'express',
    DedicatedLine: 'dedicated line',
    SelectDestinationPortAndSearchAgain: 'select the destination port and search again!',
    SoFileUpload: 'so file upload',
    OnlyJpgPng: 'Only jpg/png files can be uploaded, and no more than 500kb',
    Quantity: 'quantity',
    EnterCabinetDetailedAddress: ' enter the detailed address of the cabinet',
    EnterCabinetInstallationTime: 'enter the cabinet installation time',
    EnterContact: 'enter the contact',
    EnterContactInformation: 'enter the contact information',
    EnterContainerReturnDock: 'enter the container return dock',
    SelectTheTransportationTerms: 'select the transportation terms',
    CabinetDetailedAddress: 'detailed address of the cabinet',
    CabinetInstallationTime: 'cabinet installation time',
    Contact: 'contact',
    ContactInformation: 'contact information',
    ContainerReturnDock: 'container return dock',
    TransportationTerms: 'transportation terms',
    WhetherArrangeClearance: 'whether to arrange clearance',
    WhetherArrangeWeighing: 'whether to arrange weighing',
    LoginUseService: 'please login first! To use the service',
    AccountLoginExpiredOrLoggedInWhere: 'current account login expired or has been logged in elsewhere!',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    Normal: 'normal',
    Nervous: 'nervous',
    PositionExplosion: 'position explosion',
    SeaFullContainer: 'full container exported by sea',
    LandFullContainer: 'full container exported by land transportation',
    SeaFreightExportLCL: 'sea freight export LCL',
    ExpressQuotationQuery: 'express quotation query',
    LogOut: 'log out',
    TruckCosts: 'Truck costs',
    EnterContainerAddress: 'enter the container address',
    EnterWharf: 'enter the wharf',
    ContainerAddress: 'container address',
    Wharf: 'wharf',
    ContainerAddressCannotEmpty: 'cabinet address cannot be empty !',
    WharfCannotEmpty: 'wharf cannot be empty !',
    ContactWay: 'contact information for consultation',
    OtherService: 'Our Service: 1,Export/Import Logistics Service、Ocean Freight FCL/LCL、Air Freight、Land Transport. 2,Customs Broker、License & Certificate Application. 3,Warehouse Service. 4,Trucking Service. 5,Door to Door Servcie. 6,D.G HazMat Transportation. 7,Freezer Transportation. 8,Project Cargo.'
}   


// WEBPACK FOOTER //
// ./src/lang/en.js